// @flow
/**
 * Header Renderer
 * This component renders the site Header. It defaults to HeaderContainer but
 * can be swapped out at the router level for a custom Header of your choice.
 *
 * To use this component assign to your router config a `renderHeader` function:
 *
 * ```
 * routes: {
 *   '.': {
 *     component: TodoList,
 *     assign: {
 *       renderHeader: ({ currentUrl, hasHeaderFromServer }) => <MyHeader />,
 *     },
 *   },
 * },
 * ```
 */

import React, { type Node } from 'react';
import { connect } from 'react-redux';

import * as RouterSelectors from 'app/common/utils/RouterSelectors';
import HeaderContainer from 'app/viewport/components/HeaderContainer';

type ownProps = {
  currentUrl: string,
  hasHeaderFromServer: boolean,
  serverHeaderType?: 'universal-navigation',
};
type Props = {
  ...$Exact<ownProps>,
  renderHeader: ownProps => Node,
};

const HeaderRenderer = ({
  currentUrl,
  hasHeaderFromServer,
  renderHeader,
  serverHeaderType,
}: Props) =>
  renderHeader({ currentUrl, hasHeaderFromServer, serverHeaderType });

const defaultRenderHeader = ({ hasHeaderFromServer, serverHeaderType }) => {
  return (
    <HeaderContainer
      hasHeaderFromServer={hasHeaderFromServer}
      serverHeaderType={serverHeaderType}
    />
  );
};

const mapStateToProps = state => ({
  currentUrl: RouterSelectors.currentUrl(state) || '',
  renderHeader: state.router.current.renderHeader || defaultRenderHeader,
});

export default connect(mapStateToProps)(HeaderRenderer);
